var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 977,
    height: 1024,
    viewBox: "0 0 977 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M916.887 299.916l-321.339-265.64c-59.983-51.414-149.958-51.414-214.226 0l-321.339 265.64c-38.561 34.276-59.983 81.406-59.983 132.82v471.297c0 68.552 55.699 124.251 124.251 124.251h179.95c42.845 0 81.406-38.561 81.406-81.406v-158.527c0-25.707 21.423-47.13 47.13-47.13h115.682c25.707 0 47.13 21.423 47.13 47.13v154.243c0 42.845 38.561 81.406 81.406 81.406h179.95c68.552 0 124.251-55.699 124.251-124.251v-471.297c-4.285-47.13-25.707-94.259-64.268-128.536z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.cfef1094a96fe3d5a0fb9ad8d1fd156b.svg";
export { ForwardRef as ReactComponent };